import React, { useState } from 'react'
import propTypes from 'prop-types'

import { Button } from '@components/Button'
import { Card, CardHeading, CardContent } from '@components/layout/Card'
import { GoToDesktopModal } from '@components/Modal/GoToDesktopModal'

export const MobileCta = (props) => {
  const [showGoToDesktopModal, setShowGoToDesktopModal] = useState(false)
  const {
    sendLoginLinkPath,
    onCreateNewScenario,
    tenantSlug,
    scenario
  } = props

  if (scenario.planType !== 'implemented') {
    return null
  }

  return (
    <>
      <Card className='flex flex-col md:hidden'>
        <CardHeading className='text-center'>
          <h5 className='mb-0'>Want to get to a better outcome?</h5>
        </CardHeading>
        <CardContent className='flex flex-col gap-4'>
          <Button trackAs='Mobile: Create a new scenario' className='button !ml-0' secondary onClick={() => setShowGoToDesktopModal(true)}>
            Create a new scenario
          </Button>
          <p className='text-center'>Creating a new scenario allows you to plan for the life you want</p>
        </CardContent>
      </Card>
      <GoToDesktopModal
        open={showGoToDesktopModal} onClose={() => setShowGoToDesktopModal(false)}
        sendLoginLinkPath={sendLoginLinkPath}
        onCreateNewScenario={() => {
          setShowGoToDesktopModal(false)
          onCreateNewScenario()
        }}
        tenantSlug={tenantSlug}
      />
    </>
  )
}

MobileCta.propTypes = {
  sendLoginLinkPath: propTypes.string.isRequired,
  onCreateNewScenario: propTypes.func.isRequired,
  tenantSlug: propTypes.string.isRequired,
  scenario: propTypes.shape({
    planType: propTypes.string.isRequired,
  }).isRequired,
}
